import React, { useRef } from "react";
import { CONTACT_EMAIL } from "../content";
import useRafScroll from "../hooks/useRafScroll";
import useReducedMotion from "../hooks/useReducedMotion";

const WORDMARK = "ABAPPSTUDIO";

export default function Contact() {
  const sectionRef = useRef(null);
  const markRef = useRef(null);
  const reduced = useReducedMotion();

  // The wordmark tightens as it arrives — width axis and tracking scrubbed
  // together so it settles into the page rather than simply fading in.
  useRafScroll(() => {
    const section = sectionRef.current;
    const mark = markRef.current;
    if (!section || !mark || reduced) return;

    const rect = section.getBoundingClientRect();
    const p = Math.max(
      0,
      Math.min(1, 1 - (rect.bottom - window.innerHeight) / window.innerHeight)
    );
    mark.style.setProperty("--squeeze", String(p));
  });

  return (
    <footer className="contact" id="contact" data-act="contact" ref={sectionRef}>
      <div className="contact__top">
        <div className="contact__col">
          <span className="mono">05 — Contact</span>
          <h2 className="contact__title serif" data-reveal="up">
            Got a loop that
            <br />
            needs breaking?
          </h2>
          <a
            className="contact__mail"
            href={`mailto:${CONTACT_EMAIL}`}
            data-lens="EMAIL"
            data-reveal="up"
            style={{ "--d": "120ms" }}
          >
            <span>{CONTACT_EMAIL}</span>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </a>
        </div>

        <div className="contact__col contact__col--links">
          <div className="contact__group">
            <span className="mono">The work</span>
            <a href="https://getpulled.app" target="_blank" rel="noreferrer" data-lens="OPEN">
              Pulled <i>↗</i>
            </a>
            <a href="https://getsaved.app" target="_blank" rel="noreferrer" data-lens="OPEN">
              Saved <i>↗</i>
            </a>
            <a
              href="https://apps.apple.com/us/app/pulled-learn-to-talk-to-girls/id6756056583"
              target="_blank"
              rel="noreferrer"
              data-lens="OPEN"
            >
              Pulled on the App Store <i>↗</i>
            </a>
          </div>

          <div className="contact__group">
            <span className="mono">The studio</span>
            <a href="#method" data-lens="GO">Method</a>
            <a href="#work" data-lens="GO">Work</a>
            <a href="#top" data-lens="TOP">Back to top</a>
          </div>
        </div>
      </div>

      <div className="contact__mark" ref={markRef} aria-hidden="true">
        {WORDMARK.split("").map((ch, i) => (
          <span key={`${ch}-${i}`} style={{ "--i": i }}>
            {ch}
          </span>
        ))}
      </div>

      <div className="contact__colophon">
        <span className="mono">© {new Date().getFullYear()} AB App Studio</span>
        <span className="mono">Built in-house — React, canvas, no template</span>
        <span className="mono">All loops eventually break</span>
      </div>
    </footer>
  );
}
